export default "__VITE_ASSET__DXaeF3rq__"